module.exports = __webpack_public_path__ + "static/media/hot.e78532c8.svg";